import Lenis from "lenis";

let lenis = null;

export function initLenis() {
    lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
    });
    let rafId;
    const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
        cancelAnimationFrame(rafId);
        lenis.destroy();
        lenis = null;
    };
}

export function scrollToId(id) {
    const el = document.querySelector(id);
    if (!el) return;
    if (lenis) {
        lenis.scrollTo(el, { offset: -64 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}
